import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExperienceStatus, IconService } from '@ess-front/shared';
import { animate, style, transition, trigger } from '@angular/animations';
import { Observable, take, tap } from 'rxjs';
import { HeaderBG } from '@shared/models/header-background.enum';
import { Clipboard } from '@angular/cdk/clipboard';
import { AuthDomainService } from '@app/domain/auth-domain.service';
import { StoreService } from '@app/store/store.service';
import { ItineraryDomainService } from '@app/domain/itinerary-domain.service';
import { SnackBarService } from '@app/core/services/snack-bar/snack-bar.service';
import { TranslationDomainService } from '@app/domain/translation-domain.service';
import { marker } from '@jsverse/transloco-keys-manager/marker';
import { EssDateFormat } from '@app/utils/constants/ess-date-config';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'ess-experience-header',
  templateUrl: './experience-header.component.html',
  styleUrls: ['./experience-header.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('300ms 250ms', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('300ms', style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class ExperienceHeaderComponent {
  @Input() title = '';
  @Input() date: string | null = null;
  @Input() time: string | null = null;
  @Input() scrollRatio = 0;
  @Input() id: number | null = null;
  @Input() hash: string | null = null;
  @Input() status: ExperienceStatus | null = null;
  @Input() isBookingExperience = true;
  @Input() titleVisible = false;
  @Input() isMobileResolution = false;
  @Input() scroll$: Observable<Event> | null = null;
  @Input() headerBG: HeaderBG | null = null;
  @Input({ required: true }) isSampleTrip!: boolean;

  @Output() backEvent: EventEmitter<void> = new EventEmitter<void>();

  loggedIn$: Observable<boolean>;
  EssDateFormat = EssDateFormat;
  backIcon: SafeHtml | null;

  constructor(
    private authDomainService: AuthDomainService,
    private clipboard: Clipboard,
    private snackBarService: SnackBarService,
    private storeService: StoreService,
    private itineraryDomainService: ItineraryDomainService,
    private translationDomainService: TranslationDomainService,
    private iconService: IconService,
  ) {
    this.loggedIn$ = this.authDomainService.isAuthenticated$();
    this.backIcon = this.iconService.getIconHTML('chevron_left');
  }

  back(): void {
    this.backEvent.emit();
  }

  copyToClipboard() {
    const snackbarMessage = this.translationDomainService.translate(marker('snackbar.copiedUrl'));
    this.snackBarService.open(snackbarMessage);
    const currentUrl = window.location.href;
    this.clipboard.copy(currentUrl);
  }

  logIn() {
    const { trip } = this.storeService.getItineraryState();
    this.authDomainService
      .handleActionWithAuthentication$()
      .pipe(
        tap(isAuth => isAuth && trip && this.itineraryDomainService.updateTrip$(trip?.hash)),
        take(1),
      )
      .subscribe();
  }

  logOut() {
    this.authDomainService.logout();
  }
}
